import { AdditionalContentType, IControlType } from '@se/cp.common';
import { DataBinding } from '@se/se.platform.base';

import { CpImportControl } from './cp-import-control';
import { CpGenericControl } from './cp-generic-control';
import { CpGridDefaultGroupsControl } from './cp-grid-default-groups-control';

export type AdditionalContentControlType = (CpGenericControl | CpImportControl | CpGridDefaultGroupsControl);

/**
 * Helper per la creazione degli additional contents.
 */
export function createAdditionalContent(
    additionalContent: AdditionalContentType[],
    dataBindingContext?: DataBinding
): AdditionalContentControlType[] {
    return additionalContent.map((ctrl) => {
        switch (ctrl.controlType) {
            case IControlType.Import:
                return new CpImportControl(ctrl, dataBindingContext);
            case IControlType.DataGridDefaultGroups:
                return new CpGridDefaultGroupsControl(ctrl, dataBindingContext);
            default:
                return new CpGenericControl(ctrl);
        }
    });
}
